export const CUSTOMER_FEEDBACK = [
    {
        name: 'customer-feedback.**',
        parent: 'root',
        url: '/customer-feedback',
        lazyLoad: $transitions => {

            const $ocLazyLoad = $transitions.injector().get('$ocLazyLoad');

            return import('./customer-feedback.module')
                .then(mod => $ocLazyLoad.load(mod.CUSTOMER_FEEDBACK_MODULE))
                .catch(err => {

                    throw new Error(err);
                });
        }
    }
];



// WEBPACK FOOTER //
// ./src/app-modules/customer-feedback/customer-feedback.states.js